module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/search-card/search-card.component.css
// module id = ./src/app/home/search-card/search-card.component.css
// module chunks = main